<template>
  <div class="col-12 col-m-12 col-l-12 gdwrapper">
    <div class="col-12 col-m-12 col-l-12">
      <p>Check me</p>
      <i class="fa fa-lg fa-check-circle"></i>
    </div>
    <div class="col-12 col-m-12 col-l-12">
      <table>
        <caption>Current song registrations</caption>
        <thead>
          <tr>
            <!-- <th scope="col">ID</th> -->
            <th scope="col">Title</th>
            <th scope="col">Alt Title</th>
            <th scope="col">ISWC</th>
            <th scope="col">Samples</th>
            <th scope="col" colspan="2">Counts</th>
            <th scope="col" colspan="3">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in userStore.songRegistrations" :key="index">
            <!-- <td>{{ item.sk }}</td> -->
            <td>{{ item.title }}</td>
            <td>{{ item.altTitle }}</td>
            <td>{{ item.iswc }}</td>
            <td>
              <i class="fa fa-thumbs-down" v-if="!item.samples"></i>
              <i class="fa fa-thumbs-up" v-if="item.samples"></i>
            </td>
            <td>Ps: {{ publishers }}</td>
            <td>Ws: {{ writers }}</td>
            <td><i class="buttoni fa fa-edit "></i></td>
            <td><i class="errori fa fa-stop-circle"></i></td>
            <td><i class="buttoni fa fa-copy"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
      <!-- <p>{{  userStore.songRegistrations }}</p> -->
  </div>
</template>
<script setup>
  import { computed } from 'vue';
  import { useUserStore } from '@/libs/stores';
  const userStore = useUserStore();
  const publishers = computed(() => {
    if(Array.isArray(userStore.songRegistrations.ps)) {
      return userStore.songRegistrations.ps.length;
    } else {
      return userStore.songRegistrations.ps;
    }
  });
  const writers = computed(() => {
    if(Array.isArray(userStore.songRegistrations.ws)) {
      return userStore.songRegistrations.ws.length;
    } else {
      return userStore.songRegistrations.ws;
    }
  });

</script>